(function () {
    let tlFreeGiftClone = window.tlFreeGiftOffer;
    let overrideInstalled = false;

    function installOverride() {
        if (overrideInstalled) return;

        if (window.tlFreeGiftOffer && typeof window.tlFreeGiftOffer.detectCartData === 'function') {
            const originalDetectCart = window.tlFreeGiftOffer.detectCartData;

            window.tlFreeGiftOffer.detectCartData = async function () {
                try {
                    const cartData = await this.ajaxApi.cartGet();

                    const itemsInCart = new Map();
                    const ruleIdMapGifts = new Map();
                    if(cartData.items.length){
                        const validItem = cartData.items.find(item => !isNaN(item.price / item.presentment_price));
                        const ratio = validItem ? validItem.price / validItem.presentment_price : 1;

                        for (let i = 0; i < cartData.items.length; i++) {
                            const item = cartData.items[i];
                                
                            const itemKey = item.key;
                            const itemId = String(item.id);
                            const productId = String(item.product_id);
        
                            const appliedRuleId = this.checkLineItemIsGift(item);

                            if(appliedRuleId){
                                const giftsOfRule = ruleIdMapGifts.get(appliedRuleId) ?? [];
                                ruleIdMapGifts.set(appliedRuleId, [...giftsOfRule, {
                                    id: itemId,
                                    key: itemKey,
                                    quantity: item.quantity,
                                    price: item.final_price / ratio // Đổi sang final_price
                                }])
                            }else {
                                itemsInCart.set(itemKey, {
                                    id: itemId,
                                    price: item.final_price / ratio, // Đổi sang final_price
                                    quantity: item.quantity,
                                    title: item.title,
                                    image: item.image,
                                    productId: productId,
                                    selling_plan: !!item.selling_plan_allocation
                                })
                            }
                        }
                    }

                    this.itemsInCart = new Map(itemsInCart);
                    this.ruleIdMapGifts = new Map(ruleIdMapGifts);
                    
                    // Clear temp cart
                    this.itemsInTempCart.clear();
                    this.ruleIdMapGiftsInTempCart.clear();
                } catch (error) {
                    console.log("Error when overridden detectCartData: ", error);
                }
            };
            overrideInstalled = true;
            console.log("Salepify Free Gift - Sale Price Override Installed Successfully.");
        }
    }

    installOverride();

    if (!overrideInstalled) {
        let attempts = 0;
        const interval = setInterval(() => {
            attempts++;
            installOverride();
            if (overrideInstalled || attempts > 50) {
                clearInterval(interval);
            }
        }, 100);
    }
})();
